import { fromJS } from 'immutable';
import { PREFIX_SCREEN } from 'utils/constants';
import { ERROR_TEXT_EMPTY_STEP } from 'langs/en/errors';
import { makeDirty } from './ops.ui';

export function addStep(state, id) {
  const js = state.toJS();
  for (let i = js.form.screens.length - 1; i >= 0; i--) {
    if (!js.form.screens[i].delete) {
      js.form.screens[i].out = { [js.form.screens.length]: { condition: 'on $next if $valid' } };
      break;
    }
  }
  js.form.screens.push({
    id,
  });
  js.form.fieldOrder.push(`${PREFIX_SCREEN}${id}`);
  js.meta.uiState.fieldOrderCollapsedState.push(false);
  return makeDirty(updateStepValidity(fromJS(js)));
}

export function removeStep(state, stepIdToDelete) {
  const jsState = state.toJS();
  const idWithoutPrefix = stepIdToDelete.slice(PREFIX_SCREEN.length);
  const indexToDelete = jsState.form.screens.findIndex((screen) => screen.id === idWithoutPrefix);

  jsState.form.fieldOrder = jsState.form.fieldOrder.filter((id) => id !== stepIdToDelete);
  jsState.meta.uiState.fieldOrderCollapsedState.splice(indexToDelete, 1);

  jsState.form.screens[indexToDelete].delete = true;
  for (let i = indexToDelete - 1; i >= 0; i--) {
    if (!jsState.form.screens[i].delete) {
      jsState.form.screens[i].out = jsState.form.screens[indexToDelete].out;
      break;
    }
  }
  return makeDirty(updateStepValidity(fromJS(jsState)));
}

export function updateStepValidity(state) {
  let newState = state;
  newState = newState.deleteIn(['meta', 'invalidFormData', 'screens']);

  let indexOfLastSeenScreen = 0;
  let fieldOrScreenId;
  for (let i = 1; i < newState.getIn(['form', 'fieldOrder']).size; i++) {
    const previousFieldOrScreenId = fieldOrScreenId;
    fieldOrScreenId = newState.getIn(['form', 'fieldOrder']).get(i);
    if (!newState.hasIn(['form', 'fields', `${fieldOrScreenId}`])) {
      if (i - 1 === indexOfLastSeenScreen) {
        newState = newState.setIn(['meta', 'invalidFormData', 'screens', `${previousFieldOrScreenId}`, 'error'], fromJS({ visible: false, text: ERROR_TEXT_EMPTY_STEP }));
      }
      indexOfLastSeenScreen = i;
    }
  }
  if (indexOfLastSeenScreen === newState.getIn(['form', 'fieldOrder']).size - 1) {
    newState = newState.setIn(['meta', 'invalidFormData', 'screens', `${fieldOrScreenId}`, 'error'], fromJS({ visible: false, text: ERROR_TEXT_EMPTY_STEP }));
  }
  return newState;
}
